import { formatDate, formatDate_dd_mm_yyyy } from 'utils/DateFormatter'
import React, { useState, useEffect } from 'react'
import { getMasterdataNames, getMasterdata } from './apis'
import AddDelinquency from './AddDelinquency'
import {
  defaultPunishment,
  appealOutcomeOptions,
  appealOutcomeRevisionOptions
} from './delinquencies_constants'

const DeTable = ({ payload, onSuccess }) => {
  const [showModal, setShowModal] = useState(false)
  const [editingData, setEditingData] = useState()

  const [enrichedData, setEnrichedData] = useState(null)

  const defaultPunishments = Object.values(defaultPunishment)
  // console.log("payload",payload)

  useEffect(() => {
    const enrichData = async () => {
      if (!payload) return
      const { data, created_date, id, empId, updated_date } = payload

      const newData = {
        ...data,

        ...(data?.dePunishment && {
          dePunishment: defaultPunishments.includes(data?.dePunishment)
            ? data?.dePunishment
            : await getMasterdataNames(data?.dePunishment),
        }),


        deUnit: await getMasterdataNames(data?.deUnit),
        ...(data?.deSubUnit && {
          deSubUnit: await getMasterdataNames(data?.deSubUnit),
        }),
        
        deInitiationDate: formatDate_dd_mm_yyyy(data?.deInitiationDate),

        deResultDe: await getMasterdataNames(data?.deResultDe),
        ...(data?.deResultDeUnit && {
          deResultDeUnit: await getMasterdataNames(data?.deResultDeUnit),
        }),



        ...(data?.dePunishmentSecondary && {
          dePunishmentSecondary: defaultPunishments.includes(
            data?.dePunishmentSecondary
          )
            ? data?.dePunishmentSecondary
            : await getMasterdataNames(data?.dePunishmentSecondary),
        }),
        ...(data?.dePunishmentThird && {
          dePunishmentThird: defaultPunishments.includes(
            data?.dePunishmentThird
          )
            ? data?.dePunishmentThird
            : await getMasterdataNames(data?.dePunishmentThird),
        }),

        ...(data?.deAppealOutcome && {
          deAppealOutcome: appealOutcomeOptions.find(
            (opt) => opt.value === data?.deAppealOutcome
          )?.label,
        }),
        ...(data?.deRevisionAppealOutcome && {
          deRevisionAppealOutcome: appealOutcomeRevisionOptions.find(
            (opt) => opt.value === data?.deRevisionAppealOutcome
          )?.label,
        }),
      }

      setEnrichedData({
        data: newData,
        created_date,
        updated_date,
        id,
        empId,
      })
    }

    enrichData()
  }, [payload])

  // safe destructure
  const { data = {}, created_date, id, empId, updated_date } = enrichedData || {}

  const handleOpenModal = (data = null) => {
    setEditingData(data)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setEditingData(null)
    setShowModal(false)
  }

  const refetch = () => {
    onSuccess(empId)
  }
  const formatValue = (key, value) => {
    const statusFields = ['deStatus', 'dePunishment', 'dePunishmentSecondary', 'dePunishmentThird']

    const capitalize = (val) => {
      if (!val || typeof val !== 'string') return val
      return val.charAt(0).toUpperCase() + val.slice(1)
    }

    if (statusFields.includes(key)) {
      let badgeClass = 'badge rounded-pill '
      let displayValue = value

      switch (key) {
        case 'deStatus':
          badgeClass +=
            value === 'decided'
              ? 'bg-success'
              : value === 'pending'
                ? 'bg-warning text-dark'
                : 'bg-secondary'
          displayValue =
            value === 'completed'
              ? 'Completed'
              : value === 'pending'
                ? 'Pending'
                : capitalize(value) || 'Unknown'
          break
        case 'dePunishment':
        case 'dePunishmentSecondary':
        case 'dePunishmentThird':
          badgeClass += value !== 'None' ? 'bg-danger' : 'bg-secondary'
          displayValue = capitalize(value)
          break
        case 'deAppealOutcome':
          badgeClass +=
            value === 'upheld'
              ? 'bg-danger'
              : value === 'reversed'
                ? 'bg-success'
                : 'bg-secondary'
          displayValue = capitalize(value) || 'Not Decided'
          break
      }

      return <span className={badgeClass}>{displayValue}</span>
    }

    return capitalize(value) ?? '-' // fallback if null/undefined
  }

  // 👇 group fields in rows
  const groupedData = [
    [
      { key: 'deInitiationDate', label: 'Initiation Date' },
      { key: 'deStatus', label: 'Status' },
    ],
    [
      { key: 'deUnit', label: 'Unit' },
      { key: 'deSubUnit', label: 'Sub Unit' },
    ],
    [{ key: 'deAllegations', label: 'Allegations' }],


    [
      { key: 'deResultDe', label: 'Result of Departmental Action' },
      { key: 'dePunishment', label: 'Punishment  Based on Result of Departmental Action' }

    ],
    [
      { key: 'deDatePunishmentOrder', label: 'Date Of Punishment Order' },
      { key: 'annualStoppage', label: 'No. of increment stopped' }
    ],
    [

      { key: 'deAppealOutcome', label: 'Outcome of Appeal/Review' },
      { key: 'deDateDecisionAppeal', label: 'Date Of Decision Of Appeal/ Review'}

      // { key: 'dePunishmentSecondary', label: 'Punishment Based on Outcome of Appeal' }
    ],
    [{ key: 'annualStoppageSecondary', label: 'No. of increment stopped' },
      { key: 'dePunishmentSecondary', label: 'Punishment Based on Outcome of Appeal' }
    ],
    [
      { key: 'deRevisionAppealOutcome', label: 'Outcome of Revision Petition' },
      { key: 'deDateDecisionRevisionPetition', label: 'Date of Decission Of revision Petition' },
      // { key: 'dePunishmentThird', label: 'Punishment Based on Revision Petition' },

    ],
    [{ key: 'annualStoppageThird', label: 'No. of increment stopped' },
      { key: 'dePunishmentThird', label: 'Punishment Based on Revision Petition' }
    ],

    [{ key: 'deAnyPetiton', label: 'Whether any petition has been filed in court?' },
    { key: 'deCourtCase', label: 'Court Case Details' },
    ],



    [{ key: 'deRemark', label: 'Remarks' }],

  ]

  if (!data) return <p className="text-center">No DE Data Found</p>

  return (
    <div className="container py-4">
      <div className="card shadow mb-4">
        <div className="card-header ms-3 me-3 mt-3 bg-dark rounded text-white text-center">
          <div className="d-flex align-items-center justify-content-between ">
            <h5 className="mb-0 text-white">
              Departmental Action Details - Unit {data.deUnit}
            </h5>
            {!["ADMIN", "SUPERADMIN"].includes(
              localStorage.getItem("role"),
            ) && (
              <button
                type="button"
                onClick={() => handleOpenModal(id)}
                className="btn btn-outline-white text-white btn-lg px-3 py-2 shadow-sm"
                style={{ textDecoration: "none" }}
              >
                Update
              </button>
            )}
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <tbody>
                {groupedData.map((row, rowIndex) => {
                  const filteredRow = row.filter(
                    (cell) => data[cell.key] !== undefined
                  )

                  // Single item in the original row definition
                  if (row.length === 1 && filteredRow.length === 1) {
                    return (
                      <tr key={rowIndex}>
                        <th className="bg-light">{filteredRow[0].label}</th>
                        <td colSpan={3}>
                          {formatValue(
                            filteredRow[0].key,
                            data[filteredRow[0].key]
                          )}
                        </td>
                      </tr>
                    )
                  }

                  // Multiple items in row - normal rendering
                  return (
                    <tr key={rowIndex}>
                      {filteredRow.map((cell, cellIndex) => (
                        <React.Fragment key={cellIndex}>
                          <th className="bg-light">{cell.label}</th>
                          <td>{formatValue(cell.key, data[cell.key])}</td>
                        </React.Fragment>
                      ))}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="card-footer text-muted text-center small d-flex justify-content-between ">
          <span>
            Created Date: {formatDate_dd_mm_yyyy(created_date)}
          </span>
          <span>
            Last Updated Date: {formatDate_dd_mm_yyyy(updated_date)}
          </span>
        </div>
      </div>
      <AddDelinquency
        showModal={showModal}
        editingData={editingData}
        onSuccess={refetch}
        handleCloseModal={handleCloseModal}
        empId={empId}
      />
    </div>
  )
}

export default DeTable
